import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../../cell/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/collapse-item/style/index.js
// module id = 153
// module chunks = 0